import React, { useEffect, useState } from "react";

import { Modal, Button } from "react-bootstrap";

import './spb-toast.css';
import '../popUpStart/popUpStart.css'



export enum TypeToast {

  ERROR = "danger",

  INFORMATION = "success"

}

export interface IToastProps {

  title: string;

  message: string | undefined;

  type?: TypeToast;



}




export const SpbToast: React.FC<IToastProps> = ({ title, message, type = TypeToast.ERROR }) => {

  const [show, setShow] = useState(false);

  const toggleShow = () => setShow(!show);

 


  useEffect(() => {

    if (message) {

      setShow(true)

    } else {

      setShow(false)

    }
  

  }, [message])


  const imgBox: string = require("../../../assets/Icon-valider.svg").default;
  const imgError: string = require("../../../assets/warning.svg").default;
  return (

    <>

       <Modal show={show} onHide={toggleShow}  backdrop="static"  isOpen = {false}  centered= {true}>

        <Modal.Header  className="no-border" >

       

          <div className="imgBox " style={{ width: '100%' }}>
          {type ==TypeToast.ERROR? 
            <img src={imgError} alt=" Spb" className="image-popup" />
            :
            <img src={imgBox} alt=" Spb" className="image-popup" />}
          </div>

        </Modal.Header>

        <Modal.Body className="no-border">

      
        

          {type ==TypeToast.ERROR? 
           <div className=" textBox align-items-center ">
             {message} 
            </div>
          
          :     <div className=" textBox align-items-center ">
          Votre demande a bien été transmise au service en charge,<br />
          lequel vous contactera pour vous confirmer la résiliation.<br />
          <br />
          Un E-mail va vous être envoyé avec le récapitulatif de votre demande.
          </div>
          }
         
        </Modal.Body>

        <Modal.Footer className="no-border"> 

         

        </Modal.Footer>

      </Modal>

    </>

  )

}